@if (tour.activeTour(); as activeTour) {
  @if (blockers(); as bars) {
    <!-- "Sua vez": só bloqueia em volta do furo — o elemento destacado recebe o clique. -->
    @for (bar of bars; track $index) {
      <div class="tour-blocker" [ngStyle]="bar"></div>
    }
  } @else {
    <!-- Backdrop: captura cliques (o escurecimento vem do box-shadow do spotlight, ou do próprio
         backdrop quando o passo é centralizado, sem furo). -->
    <div class="tour-backdrop" [class.tour-backdrop--dim]="!tour.spotlight()"></div>
  }

  @if (tour.spotlight(); as rect) {
    <div
      class="tour-spotlight"
      [class.tour-spotlight--action]="tour.awaitingInteraction()"
      [style.top.px]="rect.top"
      [style.left.px]="rect.left"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height"
    ></div>
  }

  <div class="tour-pop" role="dialog" aria-modal="true" [attr.aria-label]="tour.stepTitle()" [ngStyle]="popStyle()">
    <div class="tour-progress" aria-hidden="true">
      <span class="tour-progress-bar" [style.width.%]="tour.progress() * 100"></span>
    </div>

    <button type="button" class="tour-close" aria-label="Fechar tutorial" (click)="tour.dismiss()">
      <i class="ti ti-x"></i>
    </button>

    @if (tour.preparing()) {
      <div class="tour-preparing">
        <span class="spinner-border spinner-border-sm text-primary"></span>
        <span>Carregando os dados da empresa…</span>
      </div>
    } @else if (tour.currentStep(); as step) {
      <span class="tour-eyebrow">
        <i [ngClass]="activeTour.icon"></i>
        {{ activeTour.label }} · passo {{ tour.position() }} de {{ tour.visibleSteps().length }}
      </span>

      @if (step.visual === 'flow') {
        <div class="tour-flow" aria-hidden="true">
          <div class="tour-flow-node"><span class="tour-flow-ic"><i class="ti ti-building-warehouse"></i></span>ERP</div>
          <div class="tour-flow-lane"><span class="tour-flow-dot"></span><span class="tour-flow-dot tour-flow-dot--back"></span></div>
          <div class="tour-flow-node tour-flow-node--hub"><span class="tour-flow-ic"><i class="ti ti-plug-connected"></i></span>MarketConnector</div>
          <div class="tour-flow-lane"><span class="tour-flow-dot"></span><span class="tour-flow-dot tour-flow-dot--back"></span></div>
          <div class="tour-flow-node"><span class="tour-flow-ic"><i class="ti ti-building-store"></i></span>Marketplaces</div>
        </div>
      }

      <h5 class="tour-title">{{ tour.stepTitle() }}</h5>
      <p class="tour-body" [innerHTML]="tour.stepBody()"></p>

      @if (tour.awaitingInteraction() && step.interaction; as action) {
        <div class="tour-action">
          <span class="tour-action-hand"><i class="ti ti-hand-click"></i></span>
          <span><strong>Sua vez:</strong> {{ action.hint }}</span>
        </div>
      }

      <div class="tour-actions">
        <button type="button" class="btn btn-sm btn-text-secondary px-2" (click)="tour.dismiss()">Sair</button>
        <span class="tour-actions-spacer"></span>
        @if (!tour.isFirst()) {
          <button type="button" class="btn btn-sm btn-label-secondary" (click)="tour.prev()" aria-label="Passo anterior">
            <i class="ti ti-arrow-left"></i>
          </button>
        }
        @if (tour.awaitingInteraction()) {
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="tour.next()">Pular esta etapa</button>
        } @else {
          <button type="button" class="btn btn-sm btn-primary" (click)="tour.next()">
            {{ tour.isLast() ? 'Concluir' : 'Próximo' }}
            @if (!tour.isLast()) { <i class="ti ti-arrow-right ms-1"></i> }
          </button>
        }
      </div>
      <div class="tour-keys d-none d-md-block">Use ← e → para navegar e Esc para sair.</div>
    }
  </div>
}

<!-- Comemoração ao concluir: confete + próximo passo da trilha. -->
@if (tour.celebration(); as party) {
  <div class="tour-confetti" aria-hidden="true">
    @for (piece of confetti; track $index) {
      <span class="tour-confetti-piece"
        [style.left.%]="piece.left" [style.background]="piece.color"
        [style.animation-delay.s]="piece.delay"
        [style.--rotate]="piece.rotate + 'deg'" [style.--drift]="piece.drift + 'px'"></span>
    }
  </div>
  <div class="tour-toast" role="status">
    <span class="tour-toast-ic"><i class="ti ti-trophy"></i></span>
    <div class="tour-toast-text">
      <strong>Tutorial de {{ party.tour.label }} concluído.</strong>
      @if (party.next; as nextTour) {
        <span>Próximo da trilha: {{ nextTour.label }} · {{ tour.durationLabel(nextTour) }}</span>
      } @else {
        <span>Você concluiu todos os tutoriais.</span>
      }
    </div>
    @if (party.next) {
      <button type="button" class="btn btn-sm btn-primary text-nowrap" (click)="tour.startNext()">
        Começar <i class="ti ti-arrow-right ms-1"></i>
      </button>
    }
    <button type="button" class="tour-toast-close" aria-label="Fechar" (click)="tour.closeCelebration()"><i class="ti ti-x"></i></button>
  </div>
}

<!-- Convite de primeira visita: pílula de uma linha, discreta; some sozinha (barra mostra o tempo;
     mouse em cima pausa). Só convida: o passo a passo é o popover. -->
@if (tour.nudge(); as offer) {
  <div class="tour-nudge" role="status" [style.--nudge-ttl]="tour.nudgeTtlMs + 'ms'"
    (mouseenter)="tour.pauseNudge()" (mouseleave)="tour.resumeNudge()">
    <i class="tour-nudge-ic" [ngClass]="offer.icon" aria-hidden="true"></i>
    <span class="tour-nudge-text">Tour de {{ tour.durationLabel(offer) }}</span>
    <button type="button" class="tour-nudge-go" [attr.aria-label]="'Mostrar ' + offer.label" (click)="tour.acceptNudge()">Mostrar</button>
    <button type="button" class="tour-nudge-close" aria-label="Agora não" (click)="tour.dismissNudge()"><i class="ti ti-x"></i></button>
    <span class="tour-nudge-progress" aria-hidden="true"></span>
  </div>
}
